import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { useBottomNavBar } from "../contexts/BottomNavBarContext";
import Loader from "../components/Loader";
import { Button } from "../components/Button";

const QuickResults: React.FC = () => {
  const navigate = useNavigate();
  const { benefitsSummary, isLoading } = useUser();
  const { setIsVisible } = useBottomNavBar();

  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, [setIsVisible]);

  if (isLoading) {
    return <Loader message="Loading your benefits summary..." />;
  }

  const benefitsAmount = benefitsSummary?.monthlyBenefitsAmount || 0;
  const benefitsAvailable = benefitsAmount > 0;
  const titleText = benefitsAvailable
    ? "You may be entitled to extra money each month!"
    : "Let's explore your options";

  return (
    <div className="content-container">
      {/* Blue title section matching BenefitsSummary */}
      <div className="bg-primary rounded-20 p-6 text-center quick-results-box">
        <h1 className="text-4xl">{titleText}</h1>
      </div>

      {/* Benefits Info Card (full width top row) */}
      <div className="mt-5 container-white-rounded">
        {benefitsAvailable ? (
          <p>
            Based on what you've told us, you may get up to{" "}
            <span className="font-bold">£{benefitsAmount.toFixed(2)}</span> each
            month in benefits. This is only an estimate based on your answers so
            far.
          </p>
        ) : (
          <p>
            Based on your answers so far, you may not get extra benefits right
            now.
          </p>
        )}

        <p className="mt-5">
          {benefitsAvailable
            ? "Our free calculator shows which benefits you may get and how to apply. It is easy to use and takes under 5 minutes."
            : "This is only an estimate. Use our free benefits calculator to check again. It shows what you may still get and what to do next. It is easy to use and takes under 5 minutes."}
        </p>

        <div className="mt-5 flex flex-col items-center">
          <Button
            text="Check eligibility"
            onClick={() => navigate("/full-benefits")}
          />
        </div>
      </div>

      {/* Bottom row - two equal width cards */}
      <div className="mt-5 flex flex-col lg:flex-row gap-5">
        {/* Credit Options Card */}
        <div className="lg:flex-1 container-white-rounded">
          <p>
            We can also help you search for loans and other credit products.
          </p>

          <div className="mt-5 flex flex-col items-center">
            <Button
              text="Learn more"
              onClick={() => navigate("/loans-landing")}
            />

            <p className="mt-2.5 font-bold">Representative 1333%APR</p>
          </div>
        </div>

        {/* Dashboard Card */}
        <div className="lg:flex-1 container-white-rounded">
          <p>
            You can explore everything Afforda has to offer on your dashboard
            page.
          </p>

          <div className="mt-5 flex flex-col items-center">
            <Button
              text="Visit dashboard"
              onClick={() => navigate("/customer-home")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickResults;
